export function initA11yContrast() {
    var btn = document.querySelector('[data-museum-a11y-contrast]');
    if (!btn) {
        return;
    }

    function sync() {
        var on = document.documentElement.classList.contains('museum-high-contrast');
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    if (sessionStorage.getItem('museum-a11y') === '1') {
        document.documentElement.classList.add('museum-high-contrast');
    }
    sync();

    btn.addEventListener('click', function () {
        document.documentElement.classList.toggle('museum-high-contrast');
        sessionStorage.setItem(
            'museum-a11y',
            document.documentElement.classList.contains('museum-high-contrast') ? '1' : '0'
        );
        sync();
    });
}
